import { useTranslation } from 'react-i18next';

export default function ApiState({ isLoading, error, children }) {
    const { t } = useTranslation();

    if (isLoading)
        return (
            <div className="wrapper py-8 is-flex is-justify-content-center">
                <div className="loader"></div>
            </div>
        );
    if (error)
        return (
            <div className="wrapper py-8 is-flex is-justify-content-center">
                <p>{t('error')}</p>
            </div>
        );
    return children;
}
